// User types

export const PROFESSIONAL = 1
export const CENTER = 2


// WEBPACK FOOTER //
// ./src/constants/search.js